import * as React from 'react';
import {Button, Confirm, Header, Icon, List, Segment} from "semantic-ui-react";
import {isArray} from 'lodash';
import {callDumps, deleteDump, restoreDump, translateDump} from "../actions/userActions";
import {NavLink} from "react-router-dom";

const n = (value) => value || null;

export default class Dumps extends React.Component {
	state = {
		list: false,
		altering: false,
		translating: false,
		confirm_delete: null,
		confirm_restore: null
	};
	
	alters = (altering = false, extra = {}) => this.setState({altering, ...extra});
	confirm_delete = (confirm_delete) => () => this.setState({confirm_delete});
	confirm_restore = (confirm_restore) => () => this.setState({confirm_restore});
	
	fetch = async () => {
		try {
			const list = await callDumps();
			this.setState({list});
		} catch (e) {
			this.setState({list: null});
			console.error(e);
		}
	};
	
	delete = async () => {
		try {
			const id = this.state.confirm_delete;
			this.alters(true, {confirm_delete: null});
			const result = await deleteDump(id);
			if (result.ack) {
				this.setState(state => ({
					list: result.list || state.list.filter(i => i !== id)
				}));
			} else {
				alert('Fehler beim Löschen');
			}
		} catch (e) {
			alert('Fehler, siehe Console!');
			console.error(e);
		} finally {
			this.alters(false);
		}
	};
	
	restore = async () => {
		try {
			const id = this.state.confirm_restore;
			this.alters(true, {confirm_restore: null});
			const result = await restoreDump(id);
			if (result.ack) {
				alert('Dump wurde eingespielt');
			} else {
				alert('Fehler beim wiederherstellen, Aktion kann trotzdem erfolgreich sein.');
			}
		} catch (e) {
			alert('Fehler, siehe Console!');
			console.error(e);
		} finally {
			this.alters(false);
		}
	};
	
	translate = async() => {
		try {
			this.setState({translating: true});
			const res = await translateDump();
			if (res.ack) {
				alert(`Erfolgreich ${res.done} übersetzt.`);
			} else {
				alert(`Fehler: ${res.reason}`);
			}
		} catch (e) {
			alert('Fehler beim Übersetzen...! Siehe Console.');
			console.error(e);
		} finally {
			this.setState({translating: false});
		}
	};
	
	componentDidMount() {
		this.fetch();
	}
	
	render() {
		const {list, altering, confirm_delete, confirm_restore, translating} = this.state;
		return (
			<div>
				
				<Segment style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
					
					<div style={{display: 'flex', alignItems: 'center'}}>
						<NavLink to={'/general'}><Button size={'medium'} basic icon={'caret left'}/></NavLink>
						<Header as='h3' style={{marginTop: 0, marginLeft: 5}}>
							Aktuelle Dumps
						</Header>
					</div>
					
					<div>
						<Button onClick={this.translate} loading={translating} disabled={translating} color={'black'} basic>Dump übersetzen</Button>
					</div>
					
				</Segment>
				
				<Segment padded loading={false === list || altering || translating} style={{minHeight: 100}}>
					{n(list) && <List divided>
						
						{list.map((item, id) =>
							<List.Item key={item} style={{
								paddingTop: 10,
								paddingBottom: 10,
								display: 'flex',
								alignItems: 'center'
							}}>
								
								<List.Icon name='file code'/>
								<List.Content style={{
									display: 'inline-flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									width: 'auto',
									flexGrow: 100
								}}>
									<strong>{item}</strong>
									
									<Button.Group size={'mini'}>
										<Button disabled={altering} positive icon
										        onClick={this.confirm_restore(id)}><Icon
											name={'history'}/> Wiederherstellen</Button>
										<Button.Or/>
										<Button disabled={altering} negative icon
										        onClick={this.confirm_delete(id)}><Icon
											name={'close'}/> Löschen</Button>
									</Button.Group>
								
								</List.Content>
							
							</List.Item>
						)}
					
					</List>}
					
					<Confirm
						content={'Die Wiederherstellung kann eine Weile dauern. Während dem Prozess keine weiteren Aktionen tätigen! Die Änderungen seit dem gewählten Zeitpunkt können verloren gehen. Sind sie sicher?'}
						cancelButton={'Abbrechen'}
						confirmButton={'Ok. Wiederherstellen!'}
						open={confirm_restore !== null}
						onCancel={this.confirm_restore(null)}
						onConfirm={this.restore}
					/>
					
					<Confirm
						content={'Mit dem Löschen vergeht die Möglichkeit der Wiederherstellung. Sind sie sicher?'}
						cancelButton={'Abbrechen'}
						confirmButton={'Ok. Löschen!'}
						open={confirm_delete !== null}
						onCancel={this.confirm_delete(null)}
						onConfirm={this.delete}
					/>
				</Segment>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/DumpsController.js